export function LoginHero() {
  return (
    <div className="flex justify-center">
      <div className="w-full max-w-xs lg:max-w-sm">
        <img
          src="/SigninPage.png"
          alt="Martial Arts Fitness Illustration"
          className="h-auto w-full object-contain"
        />
      </div>
    </div>
  )
}
